import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

export async function getOrgTeams() {
  return fetcher.get({ path: '/teams/organization' });
}

export async function createTeam(data) {
  return fetcher.post({
    path: '/teams',
    body: data,
  });
}

export async function updateTeam(teamId, data) {
  return fetcher.put({
    path: `/teams/${teamId}`,
    body: data,
  });
}

export async function deleteTeam(teamId) {
  return fetcher.delete({
    path: `/teams/${teamId}`,
    body: {
      id: teamId,
    },
  });
}
